"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { MapPin, Phone, Facebook, Twitter, Instagram, Mail } from "lucide-react";
const locations = [{
  id: "loc-1",
  name: "Dear EXA Studio",
  address: "香港 黃竹坑 表達藝術工作室 (預約制)"
}, {
  id: "loc-2",
  name: "合作空間 Partner Space",
  address: "各區社區中心及學校合作點"
}, {
  id: "loc-3",
  name: "攝影散步地點",
  address: "隨影像流動的城市角落"
}];
const WhatsAppIcon = ({
  className
}: {
  className?: string;
}) => <svg className={className} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
        </svg>;
const socials = [{
  id: "soc-1",
  icon: Instagram,
  label: "Instagram",
  href: "https://www.instagram.com/dear.exa/"
}, {
  id: "soc-2",
  icon: WhatsAppIcon,
  label: "WhatsApp",
  href: "https://wa.me/85292905190"
}, {
  id: "soc-3",
  icon: Mail,
  label: "Email",
  href: "mailto:mydearexa@gmail.com"
}];
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map(i => <li key={i} data-index={i}>
            <div className="h-4 w-24 bg-muted animate-pulse rounded-md" />
          </li>)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3">
        <li data-index={0}>
          <Link to="/HomePage" className="text-muted-foreground hover:text-primary transition-colors text-sm tracking-wider">首頁 Home</Link>
        </li>
        <li data-index={1}>
          <Link to="/AboutPage" className="text-muted-foreground hover:text-primary transition-colors text-sm tracking-wider">關於 About</Link>
        </li>
        <li data-index={2}>
          <Link to="/TeachingAndServicesPage" className="text-muted-foreground hover:text-primary transition-colors text-sm tracking-wider">服務 Services</Link>
        </li>
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors text-sm tracking-wider">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <section data-section-id="265041" id="footer" className="bg-background border-t border-secondary pt-16 pb-8">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          
          {}
          <div className="flex flex-col items-start">
            <Link to="/" className="mb-6 inline-block">
              <WvcLogo className="h-10 w-auto grayscale opacity-80" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed mb-6 font-default">有些話，未必能說出口。<br />但也許能被慢慢創作出來。<br />Dear EXA 是一個溫柔的空間，<br />讓藝術成為陪伴，探索內在的聲音。</p>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-foreground text-lg mb-6 tracking-widest">
              導覽 Explore
            </h3>
            <MenuProvider menu_id="41">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-foreground text-lg mb-6 tracking-widest">
              聯繫方式 Contact
            </h3>
            <ul className="space-y-5">
              {locations.map((loc, i) => <li key={loc.id} data-index={i} className="flex items-start gap-3">
                  <MapPin className="w-4 h-4 text-muted-foreground shrink-0 mt-1" />
                  <div className="flex flex-col gap-1">
                    <span className="text-sm font-default font-medium text-foreground">{loc.name}</span>
                    <span className="text-xs text-muted-foreground leading-snug">{loc.address}</span>
                  </div>
                </li>)}
              <li className="flex items-center gap-3 pt-2">
                <Phone className="w-4 h-4 text-muted-foreground shrink-0" />
                <span className="text-xs text-muted-foreground tracking-widest">+852 92905190</span>
              </li>
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-foreground text-lg mb-6 tracking-widest">
              追蹤動態 Follow
            </h3>
            <div className="flex items-center gap-4 mb-8">
              {socials.map((social, i) => {
              const Icon = social.icon;
              return <Link key={social.id} to={social.href} data-index={i} className="w-10 h-10 rounded-md bg-secondary flex items-center justify-center text-muted-foreground hover:bg-primary hover:text-primary-foreground transition-all duration-500" aria-label={social.label}>
                    <Icon className="w-4 h-4" />
                  </Link>;
            })}
            </div>
            <div className="bg-secondary/30 p-5 rounded-md border border-border">
              <h4 className="font-default font-medium text-foreground mb-2 text-sm">讓創作成為你的陪伴</h4>
              <p className="text-xs text-muted-foreground mb-4 leading-relaxed">歡迎預約個人諮詢或機構工作坊合作。</p>
              <Button asChild className="w-full bg-primary text-primary-foreground hover:opacity-90 rounded-md font-default text-xs tracking-widest">
                <Link to="/TeachingAndServicesPage">開始創作之旅</Link>
              </Button>
            </div>
          </div>

        </div>

        <Separator className="my-10 bg-secondary" />

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-muted-foreground font-default tracking-widest">
          <p>© {currentYear} Dear EXA. 親愛的表達藝術. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <Link to="#" className="hover:text-foreground transition-colors">隱私條款 Privacy</Link>
            <Link to="#" className="hover:text-foreground transition-colors">使用須知 Terms</Link>
          </div>
        </div>
      </div>
    </section>;
}